/**
 * Returns the system currency code (e.g. "PLN", "EUR").
 * @return {string}
 */
export function getCurrencyCode() {
    return process.env.VUE_APP_SYSTEM_CURRENCY;
}

/**
 * Returns the currency symbol for the system currency.
 * @return {string}
 */
export function getCurrencySymbol() {
    return new Intl.NumberFormat(process.env.VUE_APP_SYSTEM_LOCALE, {
        style: 'currency',
        currency: process.env.VUE_APP_SYSTEM_CURRENCY,
        currencyDisplay: 'symbol',
    })
        .formatToParts(0)
        .find(part => part.type === 'currency').value;
}
